import React from 'react';

const Contact: React.FC = () => {
  return (
    <div style={{padding: '24px'}}>
      <h1>Contact Us</h1>
      <img src="/images/contact.svg" alt="Contact" style={{maxWidth: '100%', height: 'auto'}} />
      {/* <p style={{maxWidth: 800}}>Email: hello@svec.example — We usually reply within 2 business days.</p> */}
    </div>
  );
};

export default Contact;
